import type { I18nFn } from '#/i18n/types/I18nFn';
import { colors } from '#/theme/theme';
import type { ListingType } from '#/types/ListingType';

function APPLICATION_STATUSES_VOLOP_ALL(i18n: I18nFn) {
  return {
    APPLIED:
      /* Status */
      i18n('New Inquiry'),
    UNDER_CONSIDERATION:
      /* Status */
      i18n('Under Consideration'),
    INTERVIEWING:
      /* Status */
      i18n('Screening'),
    MADE_OFFER:
      /* Status */
      i18n('Waiting for Response'),
    HIRED:
      /* Status */
      i18n('Resulted in Volunteering'),
    DISQUALIFIED:
      /* Status */
      i18n("Didn't Work Out"),
  } as const satisfies Record<string, string>;
}

function APPLICATION_STATUSES_SHARED_ALL(i18n: I18nFn) {
  return {
    APPLIED:
      /* Status */
      i18n('Applied'),
    UNDER_CONSIDERATION:
      /* Status */
      i18n('Under Consideration'),
    INTERVIEWING:
      /* Status */
      i18n('Interviewing'),
    MADE_OFFER:
      /* Status */
      i18n('Made Offer'),
    HIRED:
      /* Status */
      i18n('Hired'),
    DISQUALIFIED:
      /* Status */
      i18n('Disqualified'),
  } as const satisfies Record<string, string>;
}

export function APPLICATION_STATUSES_ALL(
  i18n: I18nFn,
  listingType?: ListingType,
) {
  if (listingType === 'VOLOP') return APPLICATION_STATUSES_VOLOP_ALL(i18n);
  return APPLICATION_STATUSES_SHARED_ALL(i18n);
}

export type OrgDashboardAtsApplicationStatus = keyof ReturnType<
  typeof APPLICATION_STATUSES_ALL
>;

export type PagesToShowByApplicationStatus = Record<
  OrgDashboardAtsApplicationStatus,
  number
>;

export function APPLICATION_STATUSES_ALL_KEYS(
  i18n: I18nFn,
  listingType?: ListingType,
) {
  return Object.keys(
    APPLICATION_STATUSES_ALL(i18n, listingType),
  ) as OrgDashboardAtsApplicationStatus[];
}

export function APPLICATION_STATUSES_VOLOP_ALL_KEYS() {
  return [
    'APPLIED',
    'HIRED',
    'MADE_OFFER',
    'INTERVIEWING',
    'UNDER_CONSIDERATION',
    'DISQUALIFIED',
  ] as OrgDashboardAtsApplicationStatus[];
}

// before that date, referrers were not tracked, so we don't want to show wrong data
export const APPLICATION_REFERRER_SUPPORT_DATE = '2021-04-07T12:00:00.000Z';

const COLOR_MAP = {
  APPLIED: {
    bg: colors.skyBlue,
    color: 'white',
  },
  UNDER_CONSIDERATION: {
    bg: colors.brandBlue,
    color: 'white',
  },
  INTERVIEWING: {
    bg: colors.brightPlum,
    color: 'white',
  },
  MADE_OFFER: {
    bg: colors.brandYellow,
    color: colors.darkContentGrey,
  },
  HIRED: {
    bg: colors.brandGreen,
    color: 'white',
  },
  DISQUALIFIED: {
    bg: colors.elementGrey,
    color: colors.darkContentGrey,
  },
  // RSVP statuses
  GOING: {
    bg: colors.brandGreen,
    color: colors.white,
  },
  INTERESTED: {
    bg: colors.skyBlue,
    color: colors.white,
  },
  NOT_GOING: {
    bg: colors.elementGrey,
    color: colors.darkContentGrey,
  },
};

export const getColor = (key: keyof typeof COLOR_MAP) =>
  COLOR_MAP[key] || COLOR_MAP.APPLIED;

export function RSVP_STATUSES(i18n: I18nFn) {
  return {
    GOING: i18n('Going'),
    INTERESTED: i18n('Interested'),
    NOT_GOING: i18n('Not Going'),
  } as const;
}
